/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Go_Further_ConsumptionInputs */



/**
* | output |
* | --- |
* | "Consumption" |
*
* @param {Go_Further_ConsumptionInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const go_further_consumption = /** @type {((inputs?: Go_Further_ConsumptionInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Go_Further_ConsumptionInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Consumption")
	return /** @type {LocalizedString} */ ("Consommation")
});